import { render, staticRenderFns } from "./CoolingChamberAdmiPulple.vue?vue&type=template&id=2e371417"
import script from "./CoolingChamberAdmiPulple.vue?vue&type=script&lang=js"
export * from "./CoolingChamberAdmiPulple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports